import React, { useEffect, useState } from "react";
import {
	Card,
	Row,
	Col,
	Table,
	Button,
	notification,
	Popconfirm,
	Checkbox,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { GET, POST } from "../../../../providers/useAxiosQuery";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
	arrayMove,
	SortableContext,
	useSortable,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { faBars } from "@fortawesome/pro-solid-svg-icons";
import { CSS } from "@dnd-kit/utilities";

import notificationErrors from "../../../../providers/notificationErrors";
import ModalFormQuestion from "./ModalFormQuestion";

const TblRow = ({ children, ...props }) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		setActivatorNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({
		id: props["data-row-key"],
	});
	const style = {
		...props.style,
		transform: CSS.Transform.toString(
			transform && {
				...transform,
				scaleY: 1,
			}
		),
		transition,
		...(isDragging
			? {
					position: "relative",
					zIndex: 9999,
			  }
			: {}),
	};
	return (
		<tr {...props} ref={setNodeRef} style={style} {...attributes}>
			{React.Children.map(children, (child) => {
				if (child.key === "sort") {
					return React.cloneElement(child, {
						children: (
							<FontAwesomeIcon
								icon={faBars}
								ref={setActivatorNodeRef}
								style={{
									touchAction: "none",
									cursor: "move",
								}}
								{...listeners}
							/>
						),
					});
				}
				return child;
			})}
		</tr>
	);
};

export default function PageEvaluationCategoryFormQuestion(props) {
	const { form_question_category_id } = props;

	const [toggleModalQuestion, setToggleModalQuestion] = useState({
		open: false,
		data: null,
	});
	const [dataSource, setDataSource] = useState([]);

	const { refetch: refetchSource } = GET(
		`api/form_questions?form_question_category_id=${form_question_category_id}&sort_field=order_no&sort_order=asc`,
		"form_questions_list",
		(res) =>
			setDataSource(res.data.map((item, index) => ({ ...item, key: index })))
	);

	const { mutate: mutateChangeStatus, isLoading: isLoadingChangeStatus } = POST(
		"api/form_question_change_status",
		"form_questions_list"
	);

	const handleChangeStatus = (values) => {
		mutateChangeStatus(values, {
			onSuccess: (res) => {
				if (res.success) {
					notification.success({
						message: "QUESTION",
						description: res.message,
					});
				} else {
					notification.error({
						message: "QUESTION",
						description: res.message,
					});
				}
			},
			onError: (err) => {
				notificationErrors(err);
			},
		});
	};

	useEffect(() => {
		refetchSource();

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form_question_category_id]);

	const { mutate: mutateSort } = POST(
		"api/form_question_order",
		"form_questions_list"
	);

	const onDragEnd = ({ active, over }) => {
		if (active.id !== over?.id) {
			let dataSourceTemp = [...dataSource];

			const activeIndex = dataSourceTemp.findIndex((i) => i.key === active.id);
			const overIndex = dataSourceTemp.findIndex((i) => i.key === over?.id);
			let data = arrayMove(dataSourceTemp, activeIndex, overIndex);
			setDataSource(data);

			mutateSort(
				{ data },
				{
					onSuccess: (res) => {
						if (res.success) {
							notification.success({
								message: "QUESTION",
								description: res.message,
							});
						} else {
							notification.error({
								message: "QUESTION",
								description: res.message,
							});
						}
					},
					onError: (err) => {
						notificationErrors(err);
					},
				}
			);
		}
	};

	const columns = [
		{
			key: "sort",
			title: "Sort",
			align: "center",
			width: 100,
		},
		{
			key: "action",
			title: "Action",
			align: "center",
			width: 100,
			render: (text, record) => (
				<>
					<Button
						type="link"
						className="btn-edit"
						onClick={() => {
							setToggleModalQuestion({
								open: true,
								data: record,
							});
						}}
						icon={<FontAwesomeIcon icon={faEdit} />}
					/>
				</>
			),
		},
		{
			key: "question",
			title: "Question",
			dataIndex: "question",
			width: 180,
			render: (text, record) => (
				<span
					className="quill-output"
					dangerouslySetInnerHTML={{
						__html: record.question,
					}}
				/>
			),
		},
		{
			key: "option_label",
			title: "Qption Label",
			dataIndex: "option_label",
			width: 150,
		},
		{
			key: "question_tips",
			title: "Question Tips",
			dataIndex: "question_tips",
			width: 150,
		},
		{
			key: "description",
			title: "Description",
			dataIndex: "description",
			width: 150,
		},
		{
			key: "question_type",
			title: "QuestionType",
			dataIndex: "question_type",
			width: 150,
		},
		{
			title: "Visibility",
			dataIndex: "visible",
			align: "center",
			width: 150,
			render: (_, record) => (
				<Popconfirm
					title={`Are you sure to change the status of this data?`}
					onConfirm={() => handleChangeStatus(record)}
					onCancel={() => {
						notification.error({
							message: "Survey",
							description: "Data status not change",
						});
					}}
					okText="Yes"
					cancelText="No"
				>
					<Checkbox
						className="btn-edit"
						checked={record.status === 1 ? true : false}
						disabled={isLoadingChangeStatus}
					>
						{record.status === 1 ? "Visible" : "Not Visible"}
					</Checkbox>
				</Popconfirm>
			),
		},
	];

	return (
		<Card title="Questions" className="card-questions-wrapper">
			<Row gutter={[12, 12]} id="tbl_wrapper">
				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					<Button
						type="primary"
						className="btn-main-primary"
						icon={<FontAwesomeIcon icon={faPlus} />}
						onClick={() => {
							setToggleModalQuestion({
								open: true,
								data: null,
							});
						}}
					>
						Add Question
					</Button>
				</Col>
				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					<DndContext
						modifiers={[restrictToVerticalAxis]}
						onDragEnd={onDragEnd}
					>
						<SortableContext
							// rowKey array
							items={dataSource.map((i) => i.key)}
							strategy={verticalListSortingStrategy}
						>
							<Table
								components={{
									body: {
										row: TblRow,
									},
								}}
								dataSource={dataSource}
								rowKey="key"
								pagination={false}
								bordered={false}
								scroll={{ x: "max-content" }}
								className="tbl-main-primary"
								columns={columns}
								sticky
							/>
						</SortableContext>
					</DndContext>
				</Col>
			</Row>

			<ModalFormQuestion
				toggleModalQuestion={toggleModalQuestion}
				setToggleModalQuestion={setToggleModalQuestion}
				form_question_category_id={form_question_category_id}
			/>
		</Card>
	);
}
